import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Login from '@/view/login'
import HomePage from '@/view/homepage'
import Welcome from '@/view/welcome'
import xgmm from '@/view/xgmm'
import errorpage from '@/view/xtgl/errorpage'

import rywh from '@/view/xtgl/yhgl/rywh'
import rywhadd from '@/view/xtgl/yhgl/rywhadd'
import sysbm from '@/view/xtgl/yhgl/sysbm'
import sysbmadd from '@/view/xtgl/yhgl/sysbmadd'
import jswh from '@/view/xtgl/qxgl/jswh' // 角色维护
import jswhadd from '@/view/xtgl//qxgl/jswhadd' // 角色添加
import qxwh from '@/view/xtgl/qxgl/qxwh' // 权限维护
import cdwh from '@/view/xtgl/qxgl/cdwh' // 角色维护
import cdwhadd from '@/view/xtgl/qxgl/cdwhadd'
import xtcs from '@/view/xtgl/xtcs' // 系统参数
import xtcsadd from '@/view/xtgl/xtcsadd'


// 业务
import dzddr from '@/view/ywgl/dzddr'
import dzdcx from '@/view/ywgl/dzdcx'
import kpsqcx from '@/view/ywgl/kpsqcx'
import invoice from '@/view/ywgl/invoice'
import send from '@/view/ywgl/send'
import yhdzdjklog from '@/view/ywgl/yhdzdjklog'
import kplog from '@/view/ywgl/kplog'
import fslog from '@/view/ywgl/fslog'
import xzlog from '@/view/ywgl/xzlog'
import fpcx from '@/view/ywgl/fpcx'


Vue.use(Router)

const router = new Router({ // 此行代码去除url中自带的#符号
    mode: 'history',
    routes: [
        {
            path: '/admin',
            name: 'login',

            component: Login
        },
        {
            path: '/homepage',
            name: 'HomePage',
            meta: {
                requireAuth: true
            },
            component: HomePage
        },
        {
            path: '/welcome',
            name: 'Welcome',
            meta: {
                requireAuth: true
            },
            component: Welcome
        },
        {
            path: '/xgmm',
            name: 'xgmm',
            meta: {
                requireAuth: true
            },
            component: xgmm
        }, {
            path: '/errorpage',
            name: 'errorpage',
            meta: {
                requireAuth: true
            },
            component: errorpage
        }, {
            path: '/rywh',
            name: 'rywh',
            meta: {
                requireAuth: true
            },
            component: rywh
        }, {
            path: '/rywhadd',
            name: 'rywhadd',
            meta: {
                requireAuth: true
            },
            component: rywhadd
        }, {
            path: '/sysbm',
            name: 'sysbm',
            meta: {
                requireAuth: true
            },
            component: sysbm
        }, {
            path: '/sysbmadd',
            name: 'sysbmadd',
            meta: {
                requireAuth: true
            },
            component: sysbmadd
        }, {
            path: '/cdwh',
            name: 'cdwh',
            meta: {
                requireAuth: true
            },
            component: cdwh
        }, {
            path: '/cdwhadd',
            name: 'cdwhadd',
            meta: {
                requireAuth: true
            },
            component: cdwhadd
        }, {
            path: '/jswh',
            name: 'jswh',
            meta: {
                requireAuth: true
            },
            component: jswh
        }, {
            path: '/jswhadd',
            name: 'jswhadd',
            meta: {
                requireAuth: true
            },
            component: jswhadd
        }, {
            path: '/qxwh',
            name: 'qxwh',
            meta: {
                requireAuth: true
            },
            component: qxwh
        }, {
            path: '/xtcs',
            name: 'xtcs',
            meta: {
                requireAuth: true
            },
            component: xtcs
        }, {
            path: '/xtcsadd',
            name: 'xtcsadd',
            meta: {
                requireAuth: true
            },
            component: xtcsadd
        },


        // 业务
        {
            path: '/dzddr',
            name: 'dzddr',
            meta: {
                requireAuth: true
            },
            component: dzddr
        }, {
            path: '/dzdcx',
            name: 'dzdcx',
            meta: {
                requireAuth: true
            },
            component: dzdcx
        }, {
            path: '/kpsqcx',
            name: 'kpsqcx',
            meta: {
                requireAuth: true
            },
            component: kpsqcx
        }, {
            path: '/invoice',
            name: 'invoice',
            component: invoice
        }, {
            path: '/send',
            name: 'send',
            component: send
        }, {
            path: '/yhdzdjklog',
            name: 'yhdzdjklog',
            meta: {
                requireAuth: true
            },
            component: yhdzdjklog
        }, {
            path: '/kplog',
            name: 'kplog',
            meta: {
                requireAuth: true
            },
            component: kplog
        }, {
            path: '/fslog',
            name: 'fslog',
            meta: {
                requireAuth: true
            },
            component: fslog
        }, {
            path: '/xzlog',
            name: 'xzlog',
            meta: {
                requireAuth: true
            },
            component: xzlog
        }, {
            path: '/fpcx',
            name: 'fpcx',
            meta: {
                requireAuth: true
            },
            component: fpcx
        },
    ]
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
    // console.log('Global beforeEach Guard');
    // // 你可以在这里添加权限验证逻辑
    // console.log(localStorage.getItem('islogin')!=null)
    // console.log(to)
    // console.log(from)
    if (to.path == "/admin" || to.path == "/homepage" || to.path == '/sysbmadd' || to.path == '/rywhadd' || to.path == '/jswhadd' || to.path == '/jswhadd' || to.path == '/xtcsadd' || to.path == '/errorpage' || to.path == '/welcome' || to.path == '/xgmm' || to.path == '/invoice' || to.path == '/send') {
        next()
    } else {
        var url_list = ''
        var result = false
        // console.log('结果'+localStorage.getItem("test"))
        if (localStorage.getItem("test")) {
            url_list = localStorage.getItem("test").split(',')
            // console.log(url_list)
            if (url_list != null && url_list != "") {
                for (var i = 0; i < url_list.length; i++) {
                    if (to.path == url_list[i]) {
                        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
                            if (localStorage.getItem("islogin")) { // 判断本地是否存在access_token
                                next()
                                result = true
                                break;
                            } else { // 未登录,跳转到登陆页面，并且带上 将要去的地址，方便登陆后跳转。
                                next({
                                    path: '/admin',
                                    // query:{ referrer: to.fullPath}
                                })
                            }
                        } else {
                            next()
                            result = true
                            break;
                        }
                    }
                }
            } else {
                next({
                    path: '/errorpage',
                    // query:{ referrer: to.fullPath}
                })
            }

            if (result == false) { // alert(123)
                next({
                    path: '/errorpage',
                    // query:{ referrer: to.fullPath}
                })
            }
        }
        else {
            next({
                path: '/errorpage',
                // query:{ referrer: to.fullPath}
            })
        }
    }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js